import * as sessionManager from '$domain/model/session/session.manager'
import { chatClient } from '$infrastructure/cometChat/cometChatClient'
import { getUserIdData } from '$services/user/userIdData/userIdData.service'
import { CHAT_LISTENERS } from '$utils/enumsChat'

export const loginUser = async loginInfo => {
  const sessionData = await sessionManager.loginUser(loginInfo)

  const isChatUserLogged = await chatClient.getLoggedinUser()

  if (!isChatUserLogged) {
    const chatResponse = await chatClient.loginUser(sessionData.id)
    if (chatResponse && chatResponse.code === 'ERR_UID_NOT_FOUND') {
      const userIdData = await getUserIdData()
      await chatClient.createUser(userIdData.id, userIdData.name)
      await chatClient.loginUser(userIdData.id)
    }
  }

  chatClient.addMessageListener(
    CHAT_LISTENERS.loginListenerId,
    chatClient.messageListener({
      onTextMessageReceived: textMessage => {
        chatClient.markAsDelivered(textMessage)
      },
    }),
  )
  chatClient.markLastMessagesAsDelivered()

  return sessionData
}



// WEBPACK FOOTER //
// ./src/services/session/login/login.service.ts